/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Label from "../../../components/label";
import { NavLink } from "react-router-dom";
import appRoutes from "../../../routes/appRoutes";
import DefaultImage from "../../../assets/images/default-picture.png";
import ICCheckbox from "../../../components/form/checkbox";
import MakeAPICall from "../../../apiCalls/common";
import {
  getConsultHistoryView,
  reportConnectionIssue,
  addBulkBilledIncentiveApiRoute
} from "../../../apiRoutes";

import { converToUtc } from "../../../utils/dateTimeHelper";

import moment from "moment";
import APP_CONSTANTS from "../../../constants";
import ICSelect from "../../../components/form/selectInput";
import CustomModal from "../../../components/modal";
import Loader from "../../../components/loader";
import { INCENTIVE_DEFAULT_ITEMS, INCENTIVE_DEFAULT_ITEMS_91800 } from "../../../constants/helperConstants";

class ConsultHistoryView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isProcessing: false,
      reportConnection: false,
      bookingData: null,
      apiCall: null,
      durationOfCall: null,
      incentiveList: [],
      incentiveItemSelectList: [
        {
          _id: -1,
          val: "Add Incentive"
        },
      ],
      selectedIncentive: -1,
      showIncentiveModal: false,
      showIncentiveSuccessModal: false,
      currentIncentiveGroup: ''
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getConsultDetails(this.props.location?.state?._id);
  }

  getConsultDetails = id => {
    let apiCallParam = {
      reqType: "GET",
      reqURL: getConsultHistoryView,
      dataObj: {},
      params: {
        booking_id: id
      },
      headers: {},
      successCallback: res => {
        let totalSeconds = res.data.data.consultDuration / 1000,
          minutes = parseInt(totalSeconds / 60),
          seconds = parseInt(totalSeconds % 60),
          string = "",
          string1 = "";
        if (minutes === 1) {
          string = "min";
        } else {
          string = "mins";
        }
        if (seconds === 1) {
          string1 = "sec";
        } else {
          string1 = "secs";
        }

        const appointmentData = res.data.data;

        let incentiveList = [];
        let incentiveItemSelectionList = [
          {
            _id: -1,
            val: "Add Incentive"
          }
        ];

        let currentIncentiveGroup = '';
        let currentFeeNote = '';
        if (this.props.constants.icMBSItemIncentives && this.props.constants.icMBSItemIncentives.length > 0) {
          const currentMBSItemNo = appointmentData.consultDetailMedicareId?.mbsItemNo;

          // Get incentiveGroup from API response
          currentFeeNote = appointmentData.consultDetailMedicareId?.incentiveGroup || '';

          // Fallback: find it from icMBSItemIncentives by matching mbsItemNo
          if (!currentFeeNote && currentMBSItemNo) {
            const matchingIncentive = this.props.constants.icMBSItemIncentives.find(
              incentive => incentive.mbsItemNo === String(currentMBSItemNo)
            );
            if (matchingIncentive) {
              currentFeeNote = matchingIncentive.feeNote || '';
            }
          }

          currentIncentiveGroup = currentFeeNote;

          const filteredIncentives = currentFeeNote
            ? this.props.constants.icMBSItemIncentives.filter(incentive => incentive.feeNote === currentFeeNote)
            : this.props.constants.icMBSItemIncentives;

          incentiveList = filteredIncentives.map((incentive, index) => ({
            _id: index,
            itemNo: incentive.mbsItemNo,
            description: incentive.description,
            description1: `${incentive.mbsItemNo} ${incentive.description} $${(incentive.amount).toFixed(2)}${incentive.feeNote || ''}`,
            val: `${incentive.mbsItemNo} ${incentive.description} $${(incentive.amount).toFixed(2)}${incentive.feeNote || ''}`,
            price: incentive.amount,
            incentiveGroup: incentive.feeNote
          }));

          incentiveItemSelectionList = [...incentiveItemSelectionList, ...incentiveList];
        }

        this.setState({
          bookingData: appointmentData,
          reportConnection: appointmentData.haveConnectionIssue,
          durationOfCall: minutes + string + " " + seconds + string1,
          incentiveList: incentiveList,
          incentiveItemSelectList: incentiveItemSelectionList,
          currentIncentiveGroup: currentIncentiveGroup
        });
      },
      failureCallback: err => {
        console.log("Got the error : ", err);
      },
      showPopUp: false
    };
    this.setState({ apiCall: apiCallParam });
  };

  updateConnectionIssue = event => {
    this.setState({
      reportConnection: !this.state.reportConnection
    });
    let bodyData = new FormData();
    bodyData.append("appointmentId", this.props.location?.state?._id);
    bodyData.append("haveConnectionIssue", !this.state.reportConnection);

    let apiCallParam = {
      reqType: "PUT",
      reqURL: reportConnectionIssue,
      dataObj: bodyData,
      params: {},
      headers: {},
      successCallback: res => {},
      failureCallback: err => {
        console.log("Got the error : ", err);
      },
      showPopUp: false
    };
    this.setState({ apiCall: apiCallParam });
  };

  openUrl = url => {
    window.open(url, "_blank");
  };

  setSelectedPatient = () => {
    const auth = this.props.userData;
    const patientData = this.state.bookingData.patientId;
    window.open(
      APP_CONSTANTS.pmsURL +
        "/patient/patientDetails?accessToken=" +
        auth.accessToken +
        "&patientId=" +
        patientData._id +
        "&searchType=DOCTOR" +
        "&adminName=" +
        patientData.firstName +
        " " +
        patientData.lastName,
      "_blank"
    );
  };

  closeIncentiveSuccessModal = () => {
    this.setState({
      showIncentiveSuccessModal: false
    });
  };

  handleIncentiveSelectChange = val => {
    this.setState({
      selectedIncentive: val
    });

    if (val !== -1) {
      this.setState({
        showIncentiveModal: true
      });
    }
  };

  applySelIncentive = () => {
    this.setState({
      showIncentiveModal: false,
      isProcessing: true
    });

    const selectedIncentive = this.state.incentiveList.find(
      item => item._id === this.state.selectedIncentive
    );

    let bodyData = new FormData();
    bodyData.append(
      "appointmentId",
      this.state.bookingData ? this.state.bookingData._id : ""
    );
    bodyData.append(
      "incentiveItemNo",
      selectedIncentive.itemNo
    );
    bodyData.append(
      "incentiveDescription",
      selectedIncentive.description
    );
    bodyData.append(
      "incentivePrice",
      (selectedIncentive.price).toFixed(2)
    );

    let apiCallParam = {
      reqType: "PUT",
      reqURL: addBulkBilledIncentiveApiRoute,
      dataObj: bodyData,
      params: {},
      headers: {},
      successCallback: res => {
        this.setState({
          isProcessing: false,
          showIncentiveSuccessModal: true
        });
        this.getConsultDetails(this.props.location?.state?._id);
      },
      failureCallback: err => {
        console.log("Got the error : ", err);
        this.setState({
          isProcessing: false
        });
      },
      showPopUp: false
    };
    this.setState({ apiCall: apiCallParam });
  };

  cancelSelIncentive = () => {
    this.setState({
      showIncentiveModal: false
    });
  };

  render() {
    const currentTimestamp = new Date().getTime();
    let endAddIncentiveTimestamp = 0;

    if (this.state.bookingData && this.state.bookingData.createdAt) {
      const createdDate = converToUtc(
        new Date(this.state.bookingData.createdAt)
      );
      const createdTimestamp =
        createdDate.length > 0 ? new Date(createdDate).getTime() : 0;

      endAddIncentiveTimestamp = createdTimestamp + 28 * 60 * 60 * 1000;
    }

    return (
      <div className="row rounded p-3 consult-history-view">
        <Fragment>
          {this.state.isProcessing === true && <Loader />}
          <div
            className={
              this.state.isProcessing === true ? "disableContainer" : ""
            }
          >
            <div className="col-sm-12 p-3">
              <NavLink
                to={appRoutes.consultHistory}
                className="insta-link-orange font-15 text-decoration-none"
                href="#"
              >
                <i className="fas fa-arrow-left"></i>{" "}
                <span className="ml-1 pt-1 back-btn-text">
                  {" "}
                  Back to Consult History
                </span>
              </NavLink>
            </div>

            <div className="col-sm-12">
              <div className="card p-4 custom-card">
                <div className="row">
                  <div className="col-sm-1 text-center p-0 m-0 ic-patient-pic">
                    <img
                      src={
                        this.state.bookingData
                          ? this.state.bookingData.patientId.profilePic.original
                          : DefaultImage
                      }
                      alt="ic-user-patient"
                      className="rounded-circle border patient-image"
                    />
                  </div>
                  <div className="col-sm-3 text-center p-0 mtb-auto">
                    <Label className="secondary-font m-0" title="Date:" />
                    <Label
                      className="gray p-0 m-0 ml-2"
                      title={
                        this.state.bookingData
                          ? moment(this.state.bookingData.createdAt).format(
                              "DD MMM YYYY"
                            )
                          : ""
                      }
                    />
                  </div>
                  <div className="col-sm-3 text-left p-0 mtb-auto">
                    <Label
                      className="secondary-font m-0 primary-color"
                      title="Consult ID:"
                    />
                    <Label
                      className="gray p-0 m-0 ml-2 primary-color"
                      title={
                        this.state.bookingData
                          ? this.state.bookingData.appointmentId
                          : ""
                      }
                    />
                  </div>
                  <div className="col-sm-5 custom-chk-lbl mtb-auto p-0">
                    <ICCheckbox
                      name="reportConnection"
                      onChange={event => {
                        // this.setState({
                        //   reportConnection: !this.state.reportConnection
                        // });
                        this.updateConnectionIssue(event);
                        // console.log("GOt the event : ", !event.target.value);
                      }}
                      value={this.state.reportConnection}
                      inputProps={{
                        "aria-label": "Report Connection Issue"
                      }}
                      label="Report Connection Issue"
                    />
                  </div>
                </div>
                <div className="row border-bottom mt-3"></div>
                <div className="row mt-3">
                  <div
                    className="col-sm-3 cursor-pointer external-link-pms-div patientInfoDiv d-flex flex-column"
                    onClick={() => this.setSelectedPatient()}
                  >
                    <div>
                      <i className="fas fa-external-link-alt ml-2 external-link-pms"></i>
                      <Label
                        className="secondary-font m-0 float-left cursor-pointer"
                        title={
                          this.state.bookingData
                            ? this.state.bookingData.patientId.firstName +
                              " " +
                              this.state.bookingData.patientId.lastName
                            : ""
                        }
                      />
                    </div>

                    <div className="d-flex flex-row">
                      <span style={{ paddingTop: "1px" }}>
                        <Label
                          className="secondary-font m-0 cursor-pointer"
                          title="UIN: "
                        />
                      </span>

                      <Label
                        className="gray p-0 m-0 ml-2 patient-info cursor-pointer"
                        title={
                          this.state.bookingData
                            ? this.state.bookingData.patientId.patientId
                            : ""
                        }
                      />
                    </div>
                  </div>

                  <div className="col-sm-3">
                    <Label
                      className="w-100 secondary-font m-0"
                      title="Nature of Consult"
                    />
                    <Label
                      className="gray p-0 m-0"
                      title={
                        this.state.bookingData
                          ? this.state.bookingData.consultId.consultName
                            ? this.state.bookingData.consultId.consultName
                            : this.state.bookingData.consultNature
                          : ""
                      }
                    />
                  </div>

                  {this.state.bookingData &&
                    (this.state.bookingData.isBulkBilled === undefined ||
                      this.state.bookingData.isBulkBilled === false) && (
                      <div className="col-sm-3">
                        <Label
                          className="w-100 secondary-font m-0"
                          title="Duration of Consult"
                        />
                        <Label
                          className="gray p-0 m-0"
                          title={
                            this.state.bookingData
                              ? this.state.durationOfCall
                              : "0min 0sec"
                          }
                        />
                      </div>
                    )}

                  {this.state.bookingData &&
                    this.state.bookingData.isBulkBilled !== undefined &&
                    this.state.bookingData.isBulkBilled === true && (
                      <div className="col-sm-3">
                        <Label
                          className="w-100 secondary-font m-0"
                          title="Item No"
                        />
                        <Label
                          className="gray p-0 m-0"
                          title={
                            this.state.bookingData.consultDetailMedicareId
                              ? this.state.bookingData.consultDetailMedicareId
                                  .mbsItemNo
                              : ""
                          }
                        />
                      </div>
                    )}

                  <div className="col-sm-3">
                    <Label
                      className="w-100 secondary-font m-0"
                      title="Consult Earnings"
                    />
                    <Label
                      className="gray p-0 m-0"
                      title={
                        "$" +
                        (this.state.bookingData &&
                        this.state.bookingData.appointmentPrice
                          ? (
                              this.state.bookingData.appointmentPrice.toFixed(
                                2
                              ) -
                              this.state.bookingData.PMFeeAmount -
                              this.state.bookingData.taxAmount +
                              (this.state.bookingData.isBulkIncentiveAdded &&
                              this.state.bookingData.isBulkIncentiveAdded ===
                                true
                                ? this.state.bookingData.bulkIncentiveDetails
                                    .price
                                : 0)
                            ).toFixed(2)
                          : "0.00") +
                        (this.state.currentIncentiveGroup || "")
                      }
                    />
                  </div>

                  {this.state.bookingData &&
                    this.state.bookingData.isBulkBilled !== undefined &&
                    this.state.bookingData.isBulkBilled === true && (
                      <Fragment>
                        {this.state.bookingData.isBulkIncentiveAdded &&
                          this.state.bookingData.isBulkIncentiveAdded ===
                            true && (
                            <div className="col-sm-12 mt-4">
                              <Label
                                className="w-100 gray m-0"
                                title={
                                  "Incentive Added: " +
                                  this.state.bookingData.bulkIncentiveDetails
                                    .itemNo +
                                  " " +
                                  this.state.bookingData.bulkIncentiveDetails
                                    .description +
                                  " $" +
                                  (this.state.bookingData.bulkIncentiveDetails
                                    .price).toFixed(2)
                                }
                              />
                            </div>
                          )}

                        {!this.state.bookingData.isBulkIncentiveAdded &&
                          (moment(this.state.bookingData.createdAt).format(
                            "DD-MMM-YYYY"
                          ) ===
                            moment(converToUtc(new Date())).format(
                              "DD-MMM-YYYY"
                            ) ||
                            currentTimestamp < endAddIncentiveTimestamp) && (
                            <Fragment>
                          {this.state.bookingData.medicareConcessionCardCheckBox &&
                            <div className="col-sm-5 mt-4">
                              <Label
                                className="secondary-font pb-0 primary-color mb-0 patient-concession-card"
                                title="Patient is a Concession Card Holder"
                              />
                            </div>
                          }
                              <div className={this.state.bookingData.medicareConcessionCardCheckBox ? "col-sm-6 mt-4": "offset-sm-5 col-sm-6 mt-4"}>
                              <ICSelect
                                name="incentive"
                                useId="_id"
                                useValue="val"
                              items={this.state.incentiveItemSelectList}
                                value={this.state.selectedIncentive}
                                handleChange={this.handleIncentiveSelectChange}
                              />
                            </div>
                            </Fragment>
                          )}
                      </Fragment>
                    )}
                </div>
              </div>
            </div>

            <div className="col-sm-12 mt-3">
              <div className="card p-4 custom-card">
                <div className="row patient-attached-documents">
                  <div className="col-sm-12 mt-1">
                    <Label
                      className="w-100 secondary-font m-0"
                      title="Images/Documents"
                    />
                  </div>
                  <div className="col-sm-12 mt-2">
                    <Label
                      className={
                        this.state.bookingData &&
                        !this.state.bookingData.consultImgs.length &&
                        !this.state.bookingData.consultDocs.length
                          ? "w-100 m-0"
                          : "d-none"
                      }
                      title="No Images/Documents found"
                    />
                  </div>
                  <div className="col-sm-12">
                    <div className="row p-0 m-0">
                      {this.state.bookingData &&
                        this.state.bookingData.consultImgs.map(
                          (value, index) => {
                            return (
                              <div
                                className="float-left position-relative"
                                key={index}
                              >
                                {value.original.match(
                                  /\.(jpeg|jpg|gif|png|jfif)$/
                                ) ? (
                                  <img
                                    src={value.original}
                                    alt="no-img-instant-consult"
                                    className="mt-2 mr-2 img-thumbnail att-fixed-size"
                                  />
                                ) : (
                                  <iframe
                                    title="pdfFrame"
                                    src={value.original}
                                    alt="no-img-instant-consult"
                                    className="mt-2 mr-2 img-thumbnail att-fixed-size"
                                  />
                                )}
                                <i
                                  className="fas fa-eye att-delete-btn cursor-pointer"
                                  onClick={() => {
                                    this.openUrl(value.original);
                                  }}
                                />
                                <div className="clearfix" />
                              </div>
                            );
                          }
                        )}

                      {this.state.bookingData &&
                        this.state.bookingData.consultDocs.map(
                          (value, index) => {
                            return (
                              <div
                                className="float-left position-relative"
                                key={index}
                              >
                                {value.original.match(
                                  /\.(jpeg|jpg|gif|png|jfif)$/
                                ) ? (
                                  <img
                                    src={value.original}
                                    alt="no-img-instant-consult"
                                    className="mt-2 mr-2 img-thumbnail att-fixed-size"
                                  />
                                ) : (
                                  <iframe
                                    title="pdfFrame"
                                    src={value.original}
                                    alt="no-img-instant-consult"
                                    className="mt-2 mr-2 img-thumbnail att-fixed-size"
                                  />
                                )}
                                <i
                                  className="fas fa-eye att-delete-btn cursor-pointer"
                                  onClick={() => {
                                    this.openUrl(value.original);
                                  }}
                                />
                                <div className="clearfix" />
                              </div>
                            );
                          }
                        )}
                    </div>
                  </div>

                  <div className="col-sm-12 mt-4">
                    <Label
                      className="w-100 secondary-font m-0"
                      title="Additional Information"
                    />
                    {this.state.bookingData &&
                    this.state.bookingData.consultInfo ? (
                      <Label
                        className="m-0 mt-2"
                        title={this.state.bookingData.consultInfo}
                      />
                    ) : (
                      <Label
                        className="m-0 mt-2"
                        title="No additional information found"
                      />
                    )}
                  </div>

                  {this.state.bookingData &&
                    this.state.bookingData.isBulkBilled !== undefined &&
                    this.state.bookingData.isBulkBilled === true && (
                      <div className="col-sm-12 mt-4">
                        <Label
                          className="w-100 secondary-font m-0"
                          title="Bulk-Bill Assignment of Benefit Form DB4"
                        />
                        <span
                          onClick={
                            this.state.bookingData &&
                            this.state.bookingData.bbDB4FormLink
                              ? () =>
                                  window.open(
                                    this.state.bookingData.bbDB4FormLink
                                  )
                              : ""
                          }
                        >
                          <Label
                            className={
                              this.state.bookingData &&
                              this.state.bookingData.bbDB4FormLink
                                ? "gray cursor-pointer external-link-pms-div"
                                : "gray"
                            }
                            title={
                              this.state.bookingData &&
                              this.state.bookingData.bbDB4FormLink
                                ? "View Form"
                                : "Not Available"
                            }
                          />
                        </span>
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
          <CustomModal
            openModal={this.state.showIncentiveModal}
            modalBodyContent={`
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <p class="text-center mb-0">Are you sure you want to add this <br /> Bulk-Billing Incentive to this claim?</p>
            </div>
          `}
            okayText="Confirm"
            cancelText="Cancel"
            title="Instant Consult"
            useOneButton={false}
            okayEvent={this.applySelIncentive}
            cancelEvent={this.cancelSelIncentive}
          />
          <CustomModal
            openModal={this.state.showIncentiveSuccessModal}
            modalBodyContent={`
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <p class="text-center mb-0">Bulk-Billing Incentive Added Successfully</p>
            </div>
          `}
            cancelText="Okay"
            title="Instant Consult"
            useOneButton={true}
            cancelEvent={this.closeIncentiveSuccessModal}
          />
        </Fragment>
        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCall} />
      </div>
    );
  }
}

// export default ConsultHistoryView;
const mapStateToProps = props => ({
  userData:
    props.auth && props.auth.user && props.auth.user.userData
      ? props.auth.user.userData
      : {},
  constants:
    props.auth && props.auth.user && props.auth.user.appConstant
      ? props.auth.user.appConstant
      : {}
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ConsultHistoryView));
